import { getAlertKey, getDisplayableAlerts } from 'utils/lookupHelper';
import styles from './Alerts.module.css';

import Alert from './Alert/Alert';

function Alerts({ alerts, mode, containerClasses }) {
    const classes = `${styles['alert-container']}${containerClasses ? ` ${containerClasses}` : ''}`;
    const displayableAlerts = getDisplayableAlerts(alerts);

    if (!displayableAlerts.length) return null;

    return (
        <div className={classes}>
            {displayableAlerts.map((alert) => {
                const { text, color, customNote, note, name, accessPeriod } = alert;
                return (
                    <Alert
                        key={getAlertKey(alert)}
                        text={text}
                        name={name}
                        customNote={customNote}
                        note={note}
                        color={color}
                        mode={mode}
                        accessPeriod={accessPeriod}
                    />
                );
            })}
        </div>
    );
}

export default Alerts;
